import { render, staticRenderFns } from "./stationeryHeader.vue?vue&type=template&id=cff2240c&scoped=true"
import script from "./stationeryHeader.vue?vue&type=script&lang=js"
export * from "./stationeryHeader.vue?vue&type=script&lang=js"
import style0 from "./stationeryHeader.vue?vue&type=style&index=0&id=cff2240c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff2240c",
  null
  
)

export default component.exports